const {h, render, Component} = require('preact');

class UserNameInputView extends Component {
    constructor(props) {
      super(props);
      this.changeUserNameBoxState = this.changeUserNameBoxState.bind(this);
    }

    isInputValid() {
      return (document.getElementById("v2-plaintext-input").value.trim().length > 0)
    }

    readInput() {
      return document.getElementById("v2-plaintext-input").value.trim();
    }

    changeUserNameBoxState() {
      this.props.changeUserNameBoxState(this.readInput(), this.isInputValid());
    }

    focusFormInput() {
      var userNameView = document.getElementById("user-name-view");
      userNameView.classList.add('focused');
      if (document.getElementById("v2-plaintext-input").value.trim().length > 0) {
        userNameView.classList.add('filled');
      }
    }

  focusoutFormInput() {
    var userNameView = document.getElementById("user-name-view");
    userNameView.classList.remove('focused');
    if (document.getElementById("v2-plaintext-input").value.trim().length > 0) {
        userNameView.classList.add('filled')
    }
    else {
      userNameView.classList.remove('filled')
    }
  }

  componentDidMount() {
    this.changeUserNameBoxState()
    var commentBox = document.getElementById("v2-plaintext-input")
    commentBox.addEventListener("keyup", this.changeUserNameBoxState)

    var userNameBox = document.getElementById("user-name-view");
    userNameBox.addEventListener("focusin", this.focusFormInput)
    userNameBox.addEventListener("focusout", this.focusoutFormInput)
    userNameBox.addEventListener("keyup", this.changeUserNameBoxState)
  }

  render() {
    var isGuestCheckoutFlow = !!this.props.guestName
    var filled = false
    var userName = ''
    var classes = "gig-field inputField user-name-input"
    if(isGuestCheckoutFlow) {
      filled = true
      userName = this.props.guestName
      classes = "gig-field inputField user-name-input filled"
    }
    let attributes = {
      class: 'inputField user_name_input call-back-inputs call-back-user-name-input',
      size: '40',
      maxlength: '250',
      type: 'text',
      id: 'v2-plaintext-input',
      disabled: isGuestCheckoutFlow,
      ...(isGuestCheckoutFlow && {value: userName}),
      "data-bhw":"user-name" ,
      "aria-label":"Name",
      "data-bhw-path":"user-name"
    }
    return (
      <div class="form-v2-1">
        <div class={classes} id="user-name-view">
          <label for="v2-plaintext-input">{I18n.translate('js.modules.support.userlabel')}</label>
            <input {...attributes} />
        </div>
      </div>
    )
  }
}

module.exports = UserNameInputView
